class HeadlessIDPClient {
    _networkClient;
    constructor(_networkClient){
        this._networkClient = _networkClient;
    }
    oauthAuthorizeStart = async (data)=>this._networkClient.fetchSDK({
            url: '/idp/oauth/authorize/start',
            method: 'POST',
            body: data
        });
    oauthAuthorizeSubmit = async (data)=>this._networkClient.fetchSDK({
            url: '/idp/oauth/authorize/submit',
            method: 'POST',
            body: data
        });
    oauthLogoutStart = async (data)=>this._networkClient.fetchSDK({
            url: `/oauth/logout/start`,
            method: 'POST',
            body: data
        });
}

export { HeadlessIDPClient };
//# sourceMappingURL=HeadlessIDPClient.mjs.map
